import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/auth";
import { ERole } from "../interfaces/User/newUser";

const PrivateRoute = ({ children }: { children: JSX.Element }) => {
  const location = useLocation();
  const from = location.state?.from;

  const { isAuthenticated, isLoading, isTempPassword, roleSelected } =
    useAuth();
  if (isLoading) {
    return <p>carregando...</p>;
  }
  if (!!isTempPassword) {
    return (
      <Navigate
        to="/autenticacao/mudar-senha-temporaria"
        state={{ from: from }}
        replace
      />
    );
  }

  if (
    !!isAuthenticated &&
    roleSelected === ERole.client &&
    location.pathname.includes("/meu-portfolio/meus-servicos")
  ) {
    return <Navigate to="/meu-portfolio/minhas-compras" replace />;
  }
  if (
    !!isAuthenticated &&
    roleSelected === ERole.analyst &&
    location.pathname.includes("/meu-portfolio/minhas-compras")
  ) {
    return <Navigate to="/meu-portfolio/meus-servicos" replace />;
  }

  if (!!!isAuthenticated) {
    return (
      <Navigate
        to="/autenticacao/acessar-conta"
        state={{ from: from }}
        replace
      />
    );
  }

  return children;
};

export default PrivateRoute;
